import { api } from './client';

/// timeline API クライアント = fetch のみ。レスポンスは `unknown` を返す。
/// 検証・branded 化は domain の `parseTimeline` 門番が行う (parse, don't validate / #471)。

interface TimelineApiQuery {
  limit?: number;
  type?: string;
  contactLogType?: string;
  /// 前ページの `next_cursor` をそのまま渡す keyset ページングの継続トークン。
  cursor?: string;
}

function timelineQueryString(options: TimelineApiQuery = {}): string {
  const params = new URLSearchParams();
  params.set('limit', String(options.limit ?? 50));
  if (options.type && options.type !== 'all') {
    params.set('type', options.type);
  }
  if (options.contactLogType && options.contactLogType !== 'all') {
    params.set('contactLogType', options.contactLogType);
  }
  if (options.cursor) {
    params.set('cursor', options.cursor);
  }
  return params.toString();
}

export function getFirmTimeline(
  firmId: string,
  options: TimelineApiQuery = {},
): Promise<unknown> {
  return api.get(
    `/api/firms/${encodeURIComponent(firmId)}/timeline?${timelineQueryString(options)}`,
  );
}

export function getLawyerTimeline(
  lawyerId: string,
  options: TimelineApiQuery = {},
): Promise<unknown> {
  return api.get(
    `/api/lawyers/${encodeURIComponent(lawyerId)}/timeline?${timelineQueryString(options)}`,
  );
}
